import React, { Component } from 'react';
import { AppContext } from '../../AppProvider';

import {
  withCombinedStyles,
  withComposedEnhancers
} from '../../utils/hocUtils';
import { withNamespaces } from 'react-i18next';
import { withApollo } from 'react-apollo';
import classnames from 'classnames';
import LayoutStyles from '../../styles/layout';
import TypographyStyles from '../../styles/typography';
import SpacingStyles from '../../styles/helpers/spacing';
import ReportStyles from './Report.styles';

import { Link } from 'react-router-dom';
import Breadcrumbs from '@material-ui/lab/Breadcrumbs';
import CarrierPerformanceChart from './CarrierPerformanceChart';

import moment from 'moment';

// import DataAccess from './CarrierPerformance.data.mock';
import DataAccess from './CarrierPerformance.data';

export class CarrierPerformance extends Component {
  state = {
    data: [],
    ontimeDeliveryData: [],
    ontimePickupData: [],
    loading: true,
    error: false
  };

  async componentDidMount() {
    await this._loadData();
  }

  _loadData = async () => {
    const { client: ApolloClient } = this.props;
    const { orgId } = this.context.globalProps.orgInfo;

    try {
      const data = await DataAccess.retrieveData(orgId, ApolloClient);

      this._setDataInState(data);
    } catch (error) {
      this.setState({
        error
      });
    } finally {
      this.setState({
        loading: false
      });
    }
  };

  _setDataInState = data => {
    const ontimeDeliveryData = data.map(r => ({
      carrierId: r.carrierId,
      carrierName: r.carrierName,
      scac: r.scac,
      totalCt: r.numDelivered,
      numLate: r.numLateDeliveries,
      numOnTime: r.numDelivered - r.numLateDeliveries,
      percentOnTime: r.percentOnTimeForDelivery,
      earliest: moment.utc(r.createdFromUtc).local()
    }));

    const ontimePickupData = data.map(r => ({
      carrierId: r.carrierId,
      carrierName: r.carrierName,
      scac: r.scac,
      totalCt: r.numPickedUp,
      numLate: r.numLatePickups,
      numOnTime: r.numPickedUp - r.numLatePickups,
      percentOnTime: r.percentOnTimeForPickup,
      earliest: moment.utc(r.createdFromUtc).local()
    }));

    this.setState({
      data,
      ontimeDeliveryData,
      ontimePickupData
    });
  };

  render() {
    const { classes, t } = this.props;
    const { ontimeDeliveryData, ontimePickupData, loading, error } = this.state;
    return (
      <div>
        <div className={classes.titleRootWrapper}>
          <Breadcrumbs
            separator="›"
            arial-label="Breadcrumb"
            className={classnames(classes.headline5)}
          >
            <Link className={classnames(classes.headline4)} to="/reports">
              {t('Reports')}
            </Link>
            <span>{t('Carrier Performance')}</span>
          </Breadcrumbs>
        </div>
        <CarrierPerformanceChart
          title={t('On Time Deliveries')}
          data={ontimeDeliveryData}
          loading={loading}
          error={error}
        />
        <CarrierPerformanceChart
          title={t('On Time Pickups')}
          data={ontimePickupData}
          loading={loading}
          error={error}
        />
      </div>
    );
  }
}

CarrierPerformance.contextType = AppContext;
export default withComposedEnhancers(
  CarrierPerformance,
  withNamespaces(),
  withCombinedStyles(
    LayoutStyles,
    TypographyStyles,
    SpacingStyles,
    ReportStyles
  ),
  withApollo
);
